import React, { FunctionComponent, useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { Box } from "@bca/ui-library";

const StyledContainer = styled(Box)`
  display: flex;
`;

const LatestVersionSVG: FunctionComponent = () => {
  const theme = useContext(ThemeContext);
  const color = theme.colors["primary-light-blue"];

  return (
    <StyledContainer data-testid="latest-vehicle-version">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M19.4445 18.5858C16.0581 21.9225 10.5775 21.889 7.19942 18.5109C5.48556 16.7971 4.63229 14.5207 4.6187 12.2988L2.39681 12.2852C2.05119 12.2831 1.85097 11.8375 2.12087 11.5676L5.2125 8.47598C5.38425 8.30422 5.63113 8.30573 5.805 8.4796L8.98434 11.6589C9.25757 11.9322 9.06278 12.3753 8.71716 12.3732L6.3223 12.3339C6.30863 14.1359 6.98622 15.9422 8.37718 17.3332C11.1094 20.0654 15.5532 20.0926 18.2522 17.3936C20.9758 14.67 20.9241 10.2507 18.1919 7.5185C16.9003 6.22689 15.2915 5.55051 13.6367 5.41696C13.4392 5.41575 13.2404 5.21704 13.2392 5.01954L13.2341 4.18016C13.2326 3.93328 13.4289 3.73699 13.6758 3.7385C15.7256 3.87446 17.8045 4.72652 19.3696 6.34073C22.7477 9.71878 22.806 15.2243 19.4445 18.5858Z"
          fill={color}
        />
        <path
          d="M15.9553 15.0393L15.3888 15.7482C15.2755 15.972 14.9734 16.0094 14.7845 15.8601L11.4609 13.4723V7.16713C11.4609 6.94328 11.6498 6.71942 11.9142 6.71942H12.8206C13.0472 6.71942 13.2738 6.94328 13.2738 7.16713V12.5396L15.842 14.4051C16.0309 14.5543 16.0686 14.8155 15.9553 15.0393Z"
          fill={color}
        />
      </svg>
    </StyledContainer>
  );
};

export default LatestVersionSVG;
